import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from "@/store"
import {v4 as uuidv4} from "uuid";
import moment from 'moment'
import util from '@/utils/util'
import {addTrackInfo} from "@/api/track"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: "标书对比首页",
      module: 'xsd_all'
    }
  },
  {
    path:"/wordProcess",
    name:"wordProcess",
    component: ()=>import("@/views/word/taskProcess"),
    meta: {
      title: "word版解析过程页面",
      module: 'xsd_word'
    }
  },
  {
    path:"/pdfProcess",
    name:"pdfProcess",
    component: ()=>import("@/views/pdf/taskProcess"),
    meta: {
      title: "pdf版解析过程页面",
      module: 'xsd_pdf'
    }
  },
  {
    path:"/pdfProcessExample",
    name:"pdfProcessExample",
    component: ()=>import("@/views/pdf/taskProcessExample"),
    meta: {
      title: "pdf版解析过程页面",
      module: 'xsd_pdf'
    }
  },
  {
    path:"/wordMiddleResult",
    name:"wordMiddleResult",
    component: ()=>import("@/views/word/middleResult"),
    meta: {
      title: "word版充值页面",
      module: 'xsd_word'
    }
  },
  {
    path:"/pdfMiddleResult",
    name:"pdfMiddleResult",
    component: ()=>import("@/views/pdf/middleResult"),
    meta: {
      title: "pdf版充值页面",
      module: 'xsd_pdf'
    }
  },
  {
    path:"/wordResult",
    name:"wordResult",
    component: ()=>import("@/views/word/result"),
    meta: {
      title: "word版结果页面",
      module: 'xsd_word'
    }
  },
  {
    path:"/pdfResult",
    name:"pdfResult",
    component: ()=>import("@/views/pdf/result"),
    meta: {
      title: "pdf版结果页面",
      module: 'xsd_pdf'
    }
  },{
    path:"/pdfResultExample",
    name:"pdfResultExample",
    component: ()=>import("@/views/pdf/resultExample"),
    meta: {
      title: "pdf版结果页面",
      module: 'xsd_pdf'
    }
  },
  {
    path:"/history",
    name:"history",
    component: ()=>import("@/views/word/history"),
    meta: {
      title: "历史记录页",
      module: 'xsd_all'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  let data = {
    source: "similarity",
    info: {
      actionType: 3,
      similarityPath: to.fullPath.slice(1),
    },
  };
  window.parent.postMessage(JSON.stringify(data), "*");
  next();

});
router.afterEach(async (to, from) => {
  // 分析页面  不做埋点
  if (to.meta.noTrack) {
    return
  } else {
    store.commit('user/set_preRouterId', store.state.user.routerId);
    store.commit('user/set_routerId', uuidv4())
    let from_Info = from.path === '/' ? {title: "初始进入或刷新", module: ''} : from.meta;
    from_Info['id'] = store.state.pre_routerId;
    let to_Info = to.meta;
    to_Info['id'] = store.state.user.routerId;
    let time = moment().format("YYYY-MM-DD HH:mm:ss");
    let userInfo = util.getUserInfo();
    let temp = {
      ...userInfo,
      routeFrom: from_Info,
      routeTo: to_Info,
      clickTime: time,
      eventType: "路由曝光事件",
      eventTypeCode: 2,
      moduleType: to_Info.module
    }
    // console.log(temp)
    await addTrackInfo(temp);
  }
})

export default router
